<template>
  <ERating
    class="ad-extension-merchant-rating"
    :value="value"
    :reviews="numberOfRatings"
    :reviews-url="url"
    data-test-id="merchant-rating"
  />
</template>

<script>
import { isNaturalNumber } from '~~/common/js/universal/validators';
import ERating from '~~/common/vue/components/rating';

export default {
  components: {
    ERating,
  },
  props: {
    url: ERating.props.reviewsUrl,
    rating: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 10,
    },
    numberOfRatings: {
      type: Number,
      required: true,
      validator: isNaturalNumber,
    },
  },
  computed: {
    value() {
      return parseFloat((this.rating / 2).toFixed(1));
    },
  },
};
</script>
